import { ButtonClickTrackingPlugin, enableButtonClickTracking } from '@snowplow/browser-plugin-button-click-tracking';
import { addGlobalContexts, enableActivityTracking, newTracker } from '@snowplow/browser-tracker';

export const economicBaseTracker = 'e-conomic';

let isSnowplowInitialized = false;

interface InitSnowplowParams {
    snowplowUrl: string;
    userGuid: string;
    agreementNumber: number;
    enableSnowplow: boolean;
}

const initSnowplow = ({ snowplowUrl, userGuid, agreementNumber, enableSnowplow }: InitSnowplowParams): void => {
    if (isSnowplowInitialized) {
        return;
    }

    if (!enableSnowplow) {
        return;
    }

    if (!snowplowUrl) {
        return;
    }

    isSnowplowInitialized = true;

    newTracker(economicBaseTracker, snowplowUrl, {
        appId: 'economic',
        platform: 'web',
        anonymousTracking: true,
        contexts: { webPage: true },
        plugins: [ButtonClickTrackingPlugin()],
    });

    const userContext = {
        schema: 'iglu:com.e-conomic/context_user/jsonschema/1-0-2',
        data: {
            userGuid,
            agreementNumber,
        },
    };

    addGlobalContexts([userContext]);

    enableActivityTracking({
        minimumVisitLength: 10,
        heartbeatDelay: 10,
    });

    enableButtonClickTracking({
        filter: element => {
            // Only track buttons with explicit tracking labels
            return element.hasAttribute('data-sp-button-label');
        },
    });
};

export default initSnowplow;
